<script setup lang="ts">
import IconButton from '@/components/assistant/IconButton.vue'
import SidebarIcon from '@/components/assistant/SidebarIcon.vue'
import {useAssistantStore} from '@/stores/assistant'

defineProps<{
  isExpanded: boolean
  isSidebarOpen: boolean
  showSidebarToggle: boolean
}>()

defineEmits<{
  toggleExpand: []
  toggleSidebar: []
  print: []
}>()

const assistantStore = useAssistantStore()
</script>

<template>
  <div class="h-10 px-3 shrink-0 flex flex-row gap-3 items-center print:hidden">
    <button v-if="showSidebarToggle" @click="$emit('toggleSidebar')">
      <SidebarIcon :has-unread-conversations="assistantStore.hasUnreadConversations" />
    </button>

    <IconButton
      v-tt="isExpanded ? $t('assistant.actions.collapse') : $t('assistant.actions.expand')"
      class="ml-auto"
      :icon-classes="isExpanded ? 'fa-solid fa-down-left-and-up-right-to-center' : 'fa-solid fa-up-right-and-down-left-from-center'"
      @click="$emit('toggleExpand')"
    />

    <IconButton
      v-tt="$t('assistant.actions.download')"
      :disabled="!assistantStore.activeConversationId"
      icon-classes="fa-solid fa-arrow-right-to-bracket rotate-90"
      @click="$emit('print')"
    />

    <IconButton
      v-tt="$t('assistant.actions.close')"
      icon-classes="fa-solid fa-xmark scale-[1.2]"
      @click="assistantStore.toggleVisible"
    />
  </div>
</template>
